import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import PhoneIphoneOutlinedIcon from "@material-ui/icons/PhoneIphoneOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import SendIcon from "@material-ui/icons/Send";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TelegramIcon from "@material-ui/icons/Telegram";

import Title from "../components/title";
import { getTranslate } from "../localization";

const FORM_ENDPOINT = "https://formsubmit.co/ajax/mehditalebi9675@gmail.com";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    padding: "52px 44px 90px",
    direction: theme.direction,
    textAlign: theme.direction === "rtl" ? "right" : "left",
    [theme.breakpoints.down("sm")]: { padding: "34px 22px 64px" },
    [theme.breakpoints.down("xs")]: { padding: "28px 16px 56px" },
  },
  inner: {
    width: "min(100%, 1220px)",
    margin: "0 auto",
  },
  card: {
    position: "relative",
    height: "100%",
    minWidth: 0,
    padding: 24,
    borderRadius: 23,
    overflow: "hidden",
    background: "linear-gradient(145deg,var(--surface-strong),var(--surface))",
    border: "1px solid var(--border)",
    boxShadow: "var(--shadow-md)",
    "&::before": {
      content: '\"\"',
      position: "absolute",
      width: 220,
      height: 220,
      top: -130,
      right: theme.direction === "rtl" ? "auto" : -110,
      left: theme.direction === "rtl" ? -110 : "auto",
      borderRadius: "50%",
      background: "radial-gradient(circle,var(--glow-a),transparent 70%)",
      pointerEvents: "none",
    },
    [theme.breakpoints.down("xs")]: { padding: 17, borderRadius: 18 },
  },
  title: {
    position: "relative",
    color: "var(--text-primary)",
    fontWeight: 900,
    fontSize: "clamp(1.25rem,2.1vw,1.7rem)",
    marginBottom: 9,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  lead: {
    position: "relative",
    color: "var(--text-secondary)",
    fontSize: 13,
    lineHeight: 1.95,
    marginBottom: 20,
    maxWidth: 680,
  },
  fields: {
    display: "grid",
    gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    gap: 13,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  fieldFull: { gridColumn: "1 / -1" },
  field: {
    "& .MuiOutlinedInput-root": {
      color: "var(--text-primary)",
      borderRadius: 13,
      background: "var(--input-bg)",
      transition: "background-color .2s ease, box-shadow .2s ease",
      "& fieldset": { borderColor: "var(--border)" },
      "&:hover fieldset": { borderColor: "var(--border-accent)" },
      "&.Mui-focused": {
        background: "var(--surface)",
        boxShadow: "0 0 0 3px var(--accent-soft)",
      },
      "&.Mui-focused fieldset": { borderColor: "var(--accent)", borderWidth: 1 },
    },
    "& .MuiInputBase-input, & textarea": {
      fontSize: 13,
      lineHeight: 1.7,
      textAlign: theme.direction === "rtl" ? "right" : "left",
    },
    "& input::placeholder, & textarea::placeholder": {
      color: "var(--text-muted)",
      opacity: 1,
      textAlign: theme.direction === "rtl" ? "right" : "left",
    },
  },
  submitRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 18,
  },
  submit: {
    position: "relative",
    overflow: "hidden",
    minHeight: 48,
    minWidth: 150,
    borderRadius: 12,
    padding: "8px 21px",
    color: "#fff",
    fontSize: 11,
    fontWeight: 850,
    background: "linear-gradient(135deg,#087ff5,#2e9cff)",
    boxShadow: "0 12px 30px rgba(22,139,255,.22)",
    transition: "transform .2s ease, box-shadow .2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      background: "linear-gradient(135deg,#168bff,#52b2ff)",
      boxShadow: "0 16px 36px rgba(22,139,255,.28)",
    },
    "&.Mui-disabled": { color: "rgba(255,255,255,.60)" },
  },
  buttonInner: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 9,
    width: "100%",
    direction: theme.direction,
  },
  sendIcon: { transform: theme.direction === "rtl" ? "scaleX(-1)" : "none" },
  status: {
    padding: "9px 12px",
    borderRadius: 9,
    fontSize: 11,
    lineHeight: 1.6,
  },
  success: {
    color: "#0c9a6b",
    background: "rgba(16,185,129,.08)",
    border: "1px solid rgba(16,185,129,.22)",
  },
  error: {
    color: "#e65353",
    background: "rgba(239,68,68,.08)",
    border: "1px solid rgba(239,68,68,.20)",
  },
  infoList: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: 11,
  },
  info: {
    display: "flex",
    alignItems: "center",
    gap: 13,
    minWidth: 0,
    padding: 15,
    borderRadius: 15,
    background: "var(--surface-soft)",
    border: "1px solid var(--border-soft)",
    direction: theme.direction,
    transition: "transform .2s ease, border-color .2s ease, background-color .2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      borderColor: "var(--border-accent)",
      background: "var(--accent-soft)",
    },
  },
  iconBox: {
    width: 46,
    height: 46,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 13,
    color: "var(--accent)",
    background: "var(--accent-soft)",
    border: "1px solid var(--border-accent)",
  },
  infoLabel: { color: "var(--text-muted)", fontSize: 10, marginBottom: 3 },
  infoValue: {
    minWidth: 0,
    color: "var(--text-primary)",
    fontSize: 12,
    fontWeight: 750,
    lineHeight: 1.6,
    overflowWrap: "anywhere",
  },
  socialLinks: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    marginTop: 16,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  socialLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    minHeight: 44,
    padding: "8px 12px",
    borderRadius: 11,
    color: "var(--text-soft)",
    fontSize: 10.5,
    fontWeight: 800,
    border: "1px solid var(--border)",
    background: "var(--surface-soft)",
    transition: "color .2s ease, border-color .2s ease, transform .2s ease, background-color .2s ease",
    "&:hover": {
      color: "var(--accent)",
      transform: "translateY(-2px)",
      borderColor: "var(--border-accent)",
      background: "var(--accent-soft)",
    },
  },
}));

export default function ContactScreen() {
  const classes = useStyles();
  const translate = getTranslate();
  const [status, setStatus] = useState("idle");
  const isFa = translate.locale === "fa";

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus("sending");

    try {
      const formData = new FormData(form);
      const senderName = formData.get("Name") || "Portfolio visitor";

      formData.append("_subject", `Portfolio message — ${senderName}`);
      formData.append("_captcha", "false");
      formData.append("_template", "table");
      formData.append("_replyto", formData.get("Email"));
      formData.append("Website", "mehditalebi.com");
      formData.append("Language", isFa ? "Persian" : "English");
      formData.append("Page", window.location.href);

      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (!response.ok) throw new Error("Form submission failed");

      form.reset();
      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <div className={`${classes.root} modern-page`}>
      <div className={classes.inner}>
        <Title title={translate.contactme} eyebrow={translate.contactEyebrow} />

        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} lg={7}>
            <div className={classes.card}>
              <Typography component="h2" className={classes.title}>{translate.getintouch}</Typography>
              <div className={classes.lead}>{translate.contactLead}</div>

              <form onSubmit={handleSubmit}>
                <input type="text" name="_honey" tabIndex="-1" autoComplete="off" style={{ display: "none" }} />

                <div className={classes.fields}>
                  <TextField
                    required
                    name="Name"
                    placeholder={translate.entername}
                    variant="outlined"
                    className={classes.field}
                    autoComplete="name"
                    inputProps={{ dir: isFa ? "rtl" : "ltr" }}
                  />

                  <TextField
                    required
                    type="email"
                    name="Email"
                    placeholder={translate.enteremail}
                    variant="outlined"
                    className={classes.field}
                    autoComplete="email"
                    inputProps={{
                      dir: "ltr",
                      style: { textAlign: isFa ? "right" : "left" },
                    }}
                  />

                  <TextField
                    required
                    name="Subject"
                    placeholder={translate.entersubject}
                    variant="outlined"
                    className={`${classes.field} ${classes.fieldFull}`}
                    inputProps={{ dir: isFa ? "rtl" : "ltr" }}
                  />

                  <TextField
                    required
                    multiline
                    rows={7}
                    name="Message"
                    placeholder={translate.entermessage}
                    variant="outlined"
                    className={`${classes.field} ${classes.fieldFull}`}
                    inputProps={{ dir: isFa ? "rtl" : "ltr" }}
                  />
                </div>

                <div className={classes.submitRow}>
                  <Button type="submit" disabled={status === "sending"} className={classes.submit}>
                    <span className={classes.buttonInner}>
                      <span>{status === "sending" ? translate.sending : translate.sendmessage}</span>
                      <SendIcon className={classes.sendIcon} fontSize="small" />
                    </span>
                  </Button>

                  <div aria-live="polite">
                    {status === "success" ? (
                      <div className={`${classes.status} ${classes.success}`}>{translate.messageSent}</div>
                    ) : null}
                    {status === "error" ? (
                      <div className={`${classes.status} ${classes.error}`}>{translate.messageError}</div>
                    ) : null}
                  </div>
                </div>
              </form>
            </div>
          </Grid>

          <Grid item xs={12} lg={5}>
            <div className={classes.card}>
              <Typography component="h2" className={classes.title}>{translate.contactInfoTitle}</Typography>
              <div className={classes.lead}>{translate.contactInfoLead}</div>

              <div className={classes.infoList}>
                <div className={classes.info}>
                  <div className={classes.iconBox}><PhoneIphoneOutlinedIcon /></div>
                  <div>
                    <div className={classes.infoLabel}>{translate.phone}</div>
                    <div className={classes.infoValue}>{translate.tel}</div>
                  </div>
                </div>

                <div className={classes.info}>
                  <div className={classes.iconBox}><EmailOutlinedIcon /></div>
                  <div>
                    <div className={classes.infoLabel}>{translate.email}</div>
                    <div className={classes.infoValue}>mehditalebi9675@gmail.com</div>
                  </div>
                </div>

                <div className={classes.info}>
                  <div className={classes.iconBox}><RoomOutlinedIcon /></div>
                  <div>
                    <div className={classes.infoLabel}>{translate.address}</div>
                    <div className={classes.infoValue}>{translate.street}</div>
                  </div>
                </div>
              </div>

              <div className={classes.socialLinks}>
                <a href="https://www.linkedin.com/in/mehditalebi-/" target="_blank" rel="noopener noreferrer" className={classes.socialLink}>
                  <LinkedInIcon fontSize="small" /> LinkedIn
                </a>
                <a href="https://t.me/Mehdita" target="_blank" rel="noopener noreferrer" className={classes.socialLink}>
                  <TelegramIcon fontSize="small" /> Telegram
                </a>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
